import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { withColor, withStyle, Section, Heading1, BiggerText, Text, SectionHeading, Link } from './MarketingStyles';
import CtaBox from './CtaBox';

import { inject, observer } from 'mobx-react'
import { trackEvent } from "../../utils/eventTracking"
import config from 'react-global-configuration';


@inject('utilStore', 'modalStore', 'translationStore')
@observer
class BenefitsSection extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  openModal = () => {
    trackEvent( 'Request Information - Vorteile', 'Advertisment', 'Click Button' )
    this.props.modalStore.setState('request_information', true)
  }

  render() {

    const benefits = this.props.utilStore.benefits

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <Section id="benefits">
        <BenefitsGrid>
          <TitleItem>
            <Heading1>{ text('marketing_benefits_headline') }</Heading1>
            <BiggerText>{ text('marketing_benefits_subheadline') }</BiggerText>
          </TitleItem>
          <ImageItem src="https://res.cloudinary.com/theloge/image/upload/w_600/q_auto/v1627997365/marketing/Mask_Group.jpg" />
          <BookAppointmentItem>
            <CtaBox
              title={ text('marketing_info_box_title') }
              text={ text('marketing_info_box_text') }
              buttonText={ text('marketing_info_box_button') }
              onClick={ () => this.props.scrollToCta() }
            />
          </BookAppointmentItem>

          { benefits && benefits.map((item, index) => (
              <CardItem key={ 'benefits'+index } style={{ order: index }}>
                <CardImage src={ config.get('DIRECTUS_BACKEND') + 'assets/' + item.icon.id } />
                <CardContent>
                  <CardTitle>{ item.title }</CardTitle>
                  <CardText>
                    { item.description }
                  </CardText>
                  <CardLink onClick={ this.openModal }>{ item.link_text }</CardLink>
                </CardContent>
              </CardItem>
          ))}
        </BenefitsGrid>
      </Section>
    )
  }
}

export default BenefitsSection

const CardText = styled(withColor(Text, cssVar.colors.grey)) `
  flex: 1;
`

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: top;
`

const CardLink = withColor(Link, cssVar.colors.grey)

const CardTitle = styled(Text) `
  font-weight: bold;
  font-size: 1.4em;
`

const BenefitsGrid = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: repeat(5, 1fr);
  grid-gap: 20px;
  grid-template-areas:
    "title title image"
    ". . image"
    ". . ."
    ". . ."
    "appointment appointment appointment";

  > * {
    width: 100%;
    background: ${ cssVar.colors.lightest_grey};
    height: 100%;
    padding: 30px;
  }

  ${cssVar.breakpoints.tablet} {
    display: flex;
    flex-direction: column;

    > * {
      padding: 30px;
    }
  }
`

const TitleItem = styled.div `
  grid-area: title;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${cssVar.breakpoints.tablet} {
    text-align: center;
  }
`

const ImageItem = styled.img `
  grid-area: image;
  object-fit: cover;
  padding: 0;

  ${cssVar.breakpoints.tablet} {
    display: none;
  }
`

const CardContent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const CardItem = styled.div `
  display: grid;
  grid-template-columns: 75px auto;
  grid-gap: 10px;
  

  ${cssVar.breakpoints.tablet} {
    /* :nth-child(2n) {
      background: ${ cssVar.colors.blue };
      color: white;

      * {
        color: white;
      }
    } */
  }
`

const BookAppointmentItem = styled.div `
  grid-area: appointment;
  padding: 0;

  ${cssVar.breakpoints.tablet} {
    order: 9;
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/BenefitsSection.js